import { Flex, Button } from "@chakra-ui/react";
import { DisruptedCTAProps } from "../DisruptedCTA";
import { FunnelStepSection } from "@airhelp/funnel";
import { ControlledRadioGroup, useForm } from "v2/modules/form";
import * as z from "zod";

const BUTTON_PRIMARY_TEXT = "Continue";

const FORM_OPTIONS = ["Yes", "No"] as const;

const questionSchema = z.object({
  disruptionDetectionCorrect: z.enum(FORM_OPTIONS),
});

function RadioAndCopyCTA4({
  t,
  onAnotherClaimReasonClick,
  onSubmit,
  isSubmitting,
  disruptionReason,
}: DisruptedCTAProps) {
  const { control, getValues } = useForm({
    schema: questionSchema,
    defaultValues: {
      disruptionDetectionCorrect: "Yes",
    },
  });

  const QUESTION_TEXT = `Are these details for your ${disruptionReason} flight correct?`;

  const handleSubmit = () => {
    const data = getValues("disruptionDetectionCorrect");

    if (data === "Yes") {
      onSubmit(undefined as never);
    } else {
      onAnotherClaimReasonClick();
    }
  };

  return (
    <Flex direction={{ base: "column-reverse", md: "row" }} gap="4">
      <Button
        size="l"
        onClick={handleSubmit}
        isLoading={isSubmitting}
        data-testid="claim-flight-button"
      >
        <span>{BUTTON_PRIMARY_TEXT}</span>
      </Button>

      <FunnelStepSection title={QUESTION_TEXT}>
        <ControlledRadioGroup
          name={"disruptionDetectionCorrect"}
          options={FORM_OPTIONS}
          control={control}
          renderOption={(option) => option}
        />
      </FunnelStepSection>
    </Flex>
  );
}

export default RadioAndCopyCTA4;
